import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconLock, IconAlertCircle } from '@tabler/icons-react';
import api from '../api/api';

export default function NaverCallbackPage({ setIsLoggedIn }) {
  const navigate = useNavigate();
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [linkEmail, setLinkEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [oauthParams, setOauthParams] = useState(null);
  const [naverLinkInfo, setNaverLinkInfo] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');

    if (!code || !state) {
      navigate('/login');
      return;
    }

    setOauthParams({ code, state });

    api.post('/auth/naver-login', { code, state })
      .then(res => {
        const ts = localStorage.getItem('tokenStorage') === 'local' ? localStorage : sessionStorage;
        ts.setItem('token', res.data.token);
        if (res.data.refreshToken) ts.setItem('refreshToken', res.data.refreshToken);
        setIsLoggedIn(true);
        navigate('/');
      })
      .catch(err => {
        if (err.response?.data?.code === 'ACCOUNT_EXISTS') {
          setLinkEmail(err.response.data.email);
          setNaverLinkInfo({
            naverId: err.response.data.socialId,
            accessToken: err.response.data.socialToken,
          });
          setShowLinkModal(true);
        } else {
          const msg = err.response?.data?.message || '네이버 로그인에 실패했습니다.';
          navigate('/login', { state: { error: msg } });
        }
      });
  }, [navigate, setIsLoggedIn]);

  const handleLink = async (e) => {
    e.preventDefault();
    if (!password.trim()) {
      setError('비밀번호를 입력하세요.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/auth/naver-login', {
        ...naverLinkInfo,
        password,
      });
      const ts2 = localStorage.getItem('tokenStorage') === 'local' ? localStorage : sessionStorage;
      ts2.setItem('token', res.data.token);
      if (res.data.refreshToken) ts2.setItem('refreshToken', res.data.refreshToken);
      setIsLoggedIn(true);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || '계정 연결에 실패했습니다.');
      setLoading(false);
    }
  };

  if (showLinkModal) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'var(--tblr-bg-surface, #f4f6fa)',
      }}>
        <div style={{
          background: '#fff', borderRadius: 16, padding: '40px 36px',
          maxWidth: 420, width: '100%',
          boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
        }}>
          <div style={{ textAlign: 'center', marginBottom: 24 }}>
            <div style={{
              width: 56, height: 56, borderRadius: 14,
              background: '#03C75A', color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 16px', fontSize: 24,
            }}>N</div>
            <h3 style={{ fontWeight: 700, fontSize: 20, marginBottom: 8 }}>기존 계정 연결</h3>
            <p style={{ fontSize: 14, color: '#868e96', lineHeight: 1.6 }}>
              <strong>{linkEmail}</strong> 으로 가입된 계정이 있습니다.<br />
              <strong>사이트 계정 비밀번호</strong>를 입력하면 네이버와 연결됩니다.
            </p>
          </div>

          {error && (
            <div className="alert alert-danger mb-3" style={{ borderRadius: 10, border: 'none', background: '#fff0f0', fontSize: 14 }}>
              <div className="d-flex align-items-center gap-2">
                <IconAlertCircle size={16} style={{ color: '#d63939', flexShrink: 0 }} />
                <span>{error}</span>
              </div>
            </div>
          )}

          <form onSubmit={handleLink}>
            <div className="mb-3">
              <label className="form-label fw-medium" style={{ fontSize: 14 }}>비밀번호</label>
              <div style={{ position: 'relative' }}>
                <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--tblr-muted)', pointerEvents: 'none' }}>
                  <IconLock size={17} />
                </span>
                <input
                  type="password" className="form-control" placeholder="기존 계정 비밀번호"
                  value={password} onChange={e => setPassword(e.target.value)}
                  autoFocus required
                  style={{
                    paddingLeft: 38, height: 44, borderRadius: 10, fontSize: 14,
                    border: '1.5px solid var(--tblr-border-color, #e6e7e9)',
                  }}
                />
              </div>
            </div>

            <button type="submit" disabled={loading} style={{
              width: '100%', height: 44, borderRadius: 10, fontSize: 15, fontWeight: 600,
              background: loading ? 'var(--tblr-muted)' : '#03C75A',
              border: 'none', color: '#fff', cursor: loading ? 'not-allowed' : 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            }}>
              {loading ? (<><span className="spinner-border spinner-border-sm" style={{ width: 16, height: 16 }} /> 연결 중...</>) : '계정 연결'}
            </button>

            <button type="button" onClick={() => navigate('/login')} style={{
              width: '100%', height: 44, borderRadius: 10, fontSize: 14,
              background: 'transparent', border: '1px solid var(--tblr-border-color, #e6e7e9)',
              color: 'var(--tblr-muted)', cursor: 'pointer', marginTop: 8,
            }}>
              취소
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--tblr-bg-surface, #f4f6fa)',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div className="spinner-border text-primary" style={{ width: 40, height: 40 }} />
        <p className="mt-3 text-muted">네이버 로그인 처리 중...</p>
      </div>
    </div>
  );
}
